export enum LobbyFilterLimit {
    Any = -1, // local only
    NoLimit = 1, // play can be what they want
    Pot = 2, // limited to what's in the pot
    Fixed = 4 // limited to 4 raises and 2BB per raise.
}

